import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import './style.css';

class DemoScenarios extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onChangeScenario = this.onChangeScenario.bind(this);
    this.onChangeComparingScenario = this.onChangeComparingScenario.bind(this);

  }

  /**
   * Event hander executed when the user changes the scenario
   * @param {{ label: string, value: string }} scenario Selected scenario
   */
  onChangeScenario(scenario) {
    const { setScenario } = this.props;
    setScenario(scenario);
  }


  /**
   * Event hander executed when the user changes the comparing scenario
   * @param {{ label: string, value: string }} scenario Selected comparing scenario
   */
  onChangeComparingScenario(scenario) {
    const { setComparingScenario } = this.props;
    setComparingScenario(scenario);
  }


  render() {
    const { scenarios, selectedScenario, comparingScenarios, selectedComparingScenario } = this.props;
    return (
      <div className="c-scenario">
        <div className="scenario">
          {scenarios && scenarios.length > 1 && (
            <Select classNamePrefix="react-select" placeholder="Select scenarios" options={scenarios} value={selectedScenario} onChange={this.onChangeScenario} />
          )}
          {selectedScenario && (
            <span>{selectedScenario.label}</span>
          )}
        </div>
        <div className="comparing-scenario">
          {comparingScenarios && comparingScenarios.length > 1 && (
            <Select classNamePrefix="react-select" placeholder="Select scenarios" options={comparingScenarios} value={selectedComparingScenario} onChange={this.onChangeComparingScenario} />
          )}
          {selectedComparingScenario && (
            <span>{selectedComparingScenario.label}</span>
          )}
        </div>
      </div>
    );
  }
}

DemoScenarios.propTypes = {
  scenarios: PropTypes.array.isRequired,
  comparingScenarios: PropTypes.array.isRequired,
  selectedScenario: PropTypes.object,
  selectedComparingScenario: PropTypes.object
};

DemoScenarios.defaultProps = {
  selectedScenario: null,
  selectedComparingScenario: null
};

export default DemoScenarios;



// WEBPACK FOOTER //
// ./src/components/atmo-demo/components/scenario-info/component.js